// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-ql0","content":"styles_content__XjF8U","row":"styles_row__2NDcs","footer":"styles_footer__38ZWo","phraseLength":"styles_phraseLength__1CCC9"};